(() => {
  if (customElements.get('maxler-protein-overview')) return;
  class ProteinOverview extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();this.signal=this.controller.signal;
      const signal=this.signal;
      const start=()=>queueMicrotask(()=>{if(!signal.aborted)this.start();});
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true,signal});else start();
    }
    disconnectedCallback() {
      this.controller?.abort();this.resizeObserver?.disconnect();this.headerObserver?.disconnect();
      if(this.frame)cancelAnimationFrame(this.frame);
      if(this.headerFrame)cancelAnimationFrame(this.headerFrame);
      this.targets?.forEach(target=>{target.element.style.scrollMarginTop=target.margin;});
      this.initialized=false;this.headerListening=false;this.frame=0;this.headerFrame=0;
    }
    start() {
      if(this.initialized)return;this.initialized=true;
      this.labels=JSON.parse(this.querySelector('[data-overview-labels]').textContent);
      this.grid=this.querySelector('[data-overview-grid]');this.nav=this.querySelector('[data-overview-nav]');this.navSlot=this.querySelector('.protein-overview__nav-slot');
      document.addEventListener('variantChange',event=>{
        const root=event.target.closest?.('maxler-protein-product');
        if(root?.dataset.productId!==this.dataset.productId||!Object.hasOwn(event.detail||{},'variant'))return;
        const variant=event.detail.variant;
        let meta=root.meta?.get(String(variant?.id));
        if(!root.meta){try{meta=JSON.parse(root.querySelector('[data-protein-variant-data]')?.textContent||'[]').find(v=>String(v.id)===String(variant?.id));}catch{}}
        this.update(meta);
      },{capture:true,signal:this.signal});
      document.addEventListener('shopify:section:load',()=>this.discover(),{signal:this.signal});
      document.addEventListener('shopify:section:unload',()=>queueMicrotask(()=>{if(!this.signal.aborted)this.discover();}),{signal:this.signal});
      this.nav.addEventListener('click',event=>this.navigate(event),{signal:this.signal});
      window.addEventListener('scroll',()=>this.schedule(),{passive:true,signal:this.signal});
      window.addEventListener('resize',()=>this.schedule(),{passive:true,signal:this.signal});
      const root=[...document.querySelectorAll('maxler-protein-product')].find(e=>e.dataset.productId===this.dataset.productId);
      if(root?.current&&root.meta)this.update(root.meta.get(String(root.current.id)));
      this.discover();
    }
    replace(text,values) {for(const [key,value] of Object.entries(values))text=text.replaceAll(`[${key}]`,String(value));return text;}
    update(meta) {
      const summary=meta?.summary||{},serving=summary.serving_size;
      const positive=value=>typeof value==='string'&&/^\d+(?:[.,]\d+)?$/.test(value)&&Number(value.replace(',','.'))>0;
      const protein=summary.protein_per_serving?.match(/^(\d+(?:[.,]\d+)?) g$/)?.[1];
      const energy=summary.energy_kcal_per_serving;
      const rows={
        protein:{valid:positive(protein)&&!!serving,value:protein,unit:this.labels.gram,label:this.replace(this.labels.protein,{serving}),note:summary.protein_qualifier==='on dry matter'?this.labels.dryMatter:''},
        energy:{valid:positive(energy)&&!!serving,value:energy,unit:this.labels.kcal,label:this.replace(this.labels.energy,{serving}),note:''},
        servings:{valid:Number.isInteger(meta?.servings)&&meta.servings>0&&!!meta.package?.label,value:meta?.servings,unit:'',label:this.replace(this.labels.servings,{package:meta?.package?.label}),note:''}
      };
      let count=0;
      for(const [key,data] of Object.entries(rows)){
        const node=this.querySelector(`[data-overview-metric="${key}"]`);node.hidden=!data.valid;
        if(data.valid&&count===0)node.setAttribute('data-first-visible','true');else node.removeAttribute('data-first-visible');
        if(data.valid)count++;
        node.querySelector('[data-overview-value]').textContent=data.valid?data.value:'';
        const unit=node.querySelector('[data-overview-unit]');unit.textContent=data.valid?data.unit:'';unit.hidden=!data.valid||!data.unit;
        node.querySelector('[data-overview-label]').textContent=data.valid?data.label:'';
        const note=node.querySelector('[data-overview-note]');note.textContent=data.valid?data.note:'';note.hidden=!data.valid||!data.note;
      }
      this.grid.dataset.metricCount=String(count);
      if(this.dataset.descriptionAuto==='true'){
        const text=summary.overview_whey_blend?(summary.enzyme_complex?this.labels.formulaEnzyme:this.labels.formulaWhey):this.labels.fallback;
        const box=this.querySelector('[data-overview-description]');box.replaceChildren();
        if(text){const paragraph=document.createElement('p');paragraph.textContent=text;box.append(paragraph);}
      }
    }
    discover() {
      this.targets?.forEach(target=>{target.element.style.scrollMarginTop=target.margin;});this.targets=[];
      for(const [key,label] of Object.entries(this.labels.navigation)){
        const elements=[...document.querySelectorAll(`[data-protein-section="${key}"]`)].filter(e=>e.dataset.productId===this.dataset.productId&&!e.hidden&&getComputedStyle(e).display!=='none');
        if(elements.length!==1||!elements[0].id||document.querySelectorAll(`[id="${CSS.escape(elements[0].id)}"]`).length!==1)continue;
        this.targets.push({element:elements[0],label,margin:elements[0].style.scrollMarginTop});
      }
      const list=this.nav.querySelector('ul');list.replaceChildren();
      for(const target of this.targets){const item=document.createElement('li'),link=document.createElement('a');link.href='#'+target.element.id;link.className='js-no-transition';link.textContent=target.label;target.link=link;item.append(link);list.append(item);}
      this.nav.hidden=this.targets.length===0;this.navSlot.hidden=this.nav.hidden;
      this.nav.classList.remove('is-fixed');this.navSlot.style.height='';
      this.resizeObserver?.disconnect();this.headerObserver?.disconnect();
      if(this.nav.hidden)return;
      const header=document.getElementById('SiteHeader'),wrapper=document.getElementById('HeaderWrapper');
      this.resizeObserver=new ResizeObserver(()=>this.schedule());[this.nav,header].filter(Boolean).forEach(e=>this.resizeObserver.observe(e));
      this.headerObserver=new MutationObserver(()=>this.schedule());[header,wrapper].filter(Boolean).forEach(e=>this.headerObserver.observe(e,{attributes:true,attributeFilter:['class','style']}));
      if(header&&!this.headerListening){this.headerListening=true;header.addEventListener('transitionrun',event=>{
        if(event.propertyName!=='transform'||this.nav.hidden)return;
        const until=performance.now()+600;
        const tick=()=>{this.schedule();if(!this.signal.aborted&&performance.now()<until)this.headerFrame=requestAnimationFrame(tick);};
        if(this.headerFrame)cancelAnimationFrame(this.headerFrame);this.headerFrame=requestAnimationFrame(tick);
      },{signal:this.signal});}
      this.schedule();
    }
    headerBottom() {
      const header=document.getElementById('SiteHeader');if(!header)return 0;
      const rect=header.getBoundingClientRect(),style=getComputedStyle(header);
      return ['fixed','sticky'].includes(style.position)&&style.display!=='none'&&style.visibility!=='hidden'&&Number(style.opacity)>0?Math.max(0,rect.bottom):0;
    }
    schedule() {if(this.nav?.hidden||this.frame||this.signal.aborted)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.position();});}
    position() {
      const header=this.headerBottom(),height=this.nav.getBoundingClientRect().height;
      this.style.setProperty('--protein-overview-header-offset',`${header}px`);
      const fixed=this.navSlot.getBoundingClientRect().top<=header;
      const gap=parseFloat(getComputedStyle(this.navSlot).paddingBottom)||0;
      this.navSlot.style.height=fixed?`${height+gap}px`:'';this.nav.classList.toggle('is-fixed',fixed);
      const offset=header+height+16;
      for(const target of this.targets)target.element.style.scrollMarginTop=`${offset}px`;
      const active=[...this.targets].reverse().find(target=>target.element.getBoundingClientRect().top<=offset+40)||this.targets[0];
      for(const target of this.targets){if(target===active)target.link.setAttribute('aria-current','location');else target.link.removeAttribute('aria-current');}
    }
    navigate(event) {
      const link=event.target.closest('a');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.altKey||event.shiftKey)return;
      const target=this.targets.find(row=>row.link===link);if(!target)return;
      event.preventDefault();this.position();
      const url=new URL(location.href);url.hash=target.element.id;history.replaceState(history.state,'',url);
      const header=document.getElementById('SiteHeader');
      const headerSpace=Math.max(this.headerBottom(),header?.getBoundingClientRect().height||0);
      const offset=headerSpace+this.nav.getBoundingClientRect().height+16;
      window.scrollTo({top:Math.max(0,target.element.getBoundingClientRect().top+scrollY-offset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
  }
  customElements.define('maxler-protein-overview',ProteinOverview);
})();
